<template>
  <div class="reserve-tag-selector">
    <v-progress-linear v-if="loading" indeterminate color="primary" aria-label="讀取約診標籤"/>
    <v-alert v-if="error" type="error" text dense role="alert">
      {{ error }}
      <v-btn small text @click="$emit('retry')">重新讀取</v-btn>
    </v-alert>
    <section v-for="section in sections" :key="section.key" class="tag-section" :class="{ 'smart-tag-section': section.key === 'smart' }">
      <div class="d-flex align-center justify-space-between flex-wrap mb-2" style="gap: 8px;">
        <h3 class="text-subtitle-2 font-weight-bold">{{ section.title }}</h3>
        <v-btn v-if="section.key === 'smart' && canAccess('careTemplates')" small text color="primary" :disabled="disabled" :to="{ name: 'CareTemplateList' }">
          點我設定智能個管師標籤
        </v-btn>
        <v-btn v-if="section.key === 'custom'" small text color="primary" :disabled="loading || disabled || Boolean(error)" @click="$emit('edit-custom')">
          點我設定標籤
        </v-btn>
      </div>
      <div class="d-flex flex-wrap" :class="{ 'smart-tag-options': section.key === 'smart' }" style="gap: 8px 16px;">
        <v-checkbox
          v-for="tag in section.tags" :key="String(tag.tag_id)"
          :input-value="isSelected(tag.tag_id, section.key)" :label="tag.content"
          :disabled="loading || disabled || Boolean(error)" hide-details class="mt-0 pt-0"
          :color="section.key === 'smart' ? 'primary' : undefined"
          @change="toggleTag(tag.tag_id, $event, section.key)"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isSmartCareTag } from '@/utils/smartCareReserve';

export default {
  name: 'ReserveTagSelector',
  props: {
    value: { type: Array, default: () => [] },
    smartValue: { type: Array, default: () => [] },
    smartEnabled: Boolean,
    items: { type: Array, default: () => [] },
    loading: Boolean,
    disabled: Boolean,
    error: { type: String, default: '' },
  },
  computed: {
    ...mapGetters(['canAccess']),
    sections() {
      const items = this.items.filter(tag => tag.content && tag.content.trim());
      const custom = { key: 'custom', title: this.smartEnabled ? '自訂約診標籤' : '約診標籤', tags: items.filter(tag => !isSmartCareTag(tag)) };
      return this.smartEnabled ? [{ key: 'smart', title: '智能個管師標籤', tags: items.filter(isSmartCareTag) }, custom] : [custom];
    },
  },
  methods: {
    isSelected(id, section = 'custom') { return (section === 'smart' ? this.smartValue : this.value).some(value => String(value) === String(id)); },
    toggleTag(id, selected, section = 'custom') {
      if (this.loading || this.disabled || this.error) return;
      // 保留另一區與尚未載入的既有 ID，不因分類或重新取得清單而清除貼標。
      const ids = (section === 'smart' ? this.smartValue : this.value).filter(value => String(value) !== String(id));
      if (selected) ids.push(id);
      this.$emit(section === 'smart' ? 'update:smart-value' : 'input', ids);
    },
  },
};
</script>

<style scoped>
.tag-section { border: 1px solid #dedede; border-radius: 6px; padding: 12px 16px; }
.tag-section + .tag-section { margin-top: 12px; }
.smart-tag-section { border-color: #88c9c4; background: #f7fcfb; }
.smart-tag-options { max-height: 160px; overflow-y: auto; overscroll-behavior-y: contain; padding: 4px; }
</style>
